import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from './SelfInspectIntro.styles';
import driveUpContextImage from '../../../assets/images/driveUpContext.png';

const SelfInspectIntro = props => {
  const { classes } = props;

  return (
    <React.Fragment>
      <div className={cn('flex-1', 'col-center-center', 'px-20')}>
        <img src={driveUpContextImage} style={{ width: 300 }} />

        <h3>Welcome to Self Inspect!</h3>
        <div>
          This inspection will guide you through your home. Please answer as many questions as you can and take photos
          when required. Make sure the photos are in landscape mode.
        </div>
      </div>
    </React.Fragment>
  );
};

SelfInspectIntro.propTypes = {};

SelfInspectIntro.defaultProps = {};

export default withStyles(styles)(SelfInspectIntro);
